import { HTTPClient } from "./Client";

const RecuperacaoDeSenhaApi = {

  emailRecuperarSenhaAsync: async (email) => {
    const response = await HTTPClient.post(
      "/RecuperacaoDeSenha/SolicitarRecuperacaoDeSenha",
      { email }
    );
    return response.data;
  },
  

  redefinirSenhaAsync: async (token, novaSenha) => {
    const response = await HTTPClient.post(
      "/RecuperacaoDeSenha/RedefinirSenha",
      { token, novaSenha }
    );
    return response.data;
  },
};

export default RecuperacaoDeSenhaApi;
